let routeLoading = false;
const listeners = new Set();

function notify() {
  listeners.forEach((listener) => listener());
}

export function subscribeRouteLoading(listener) {
  listeners.add(listener);
  listener(routeLoading);
  return () => listeners.delete(listener);
}

export function getRouteLoading() {
  return routeLoading;
}

export function setRouteLoading(next) {
  const value = Boolean(next);
  if (routeLoading === value) return;
  routeLoading = value;
  notify();
}
